import React, { useState } from 'react';
import {
  ChakraProvider,
  Container,
  Input,
  Text,
  Heading,
  Button,
} from '@chakra-ui/react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

const App = () => {
  const [inCount, setInCount] = useState(0);
  const [speed, setSpeed] = useState(0);
  const [password, setPassword] = useState('');

  const HandleUpdate = async () => {
    const myPromise = axios.get(
      `https://node-cron-2.herokuapp.com/update?time=${speed}&initialStart=${inCount}&password=${password}`
    );
    toast.promise(myPromise, {
      loading: 'Updating...',
      success: (res) => {
        return 'Updated Succesfully !';
      },
      error: (err) => {
        return 'Password Entered is Wrong ! Please Enter the correct one';
      },
    });
  };

  return (
    <>
      <Toaster position='top-center' />
      <ChakraProvider>
        <Container display='flex' flexDirection='column' mt={12}>
          <Heading mb={10}>Update Speed</Heading>
          <Text mb='8px'>Speed (in seconds)</Text>
          <Input
            type='number'
            variant='outline'
            placeholder='12'
            onChange={(e) => {
              setSpeed(e.target.value);
            }}
          />
          <Text mb='8px'>Initial Count</Text>
          <Input
            type='number'
            variant='outline'
            placeholder='1000'
            onChange={(e) => setInCount(e.target.value)}
          />
          <Text mb='8px'>Password</Text>
          <Input
            type='password'
            variant='outline'
            placeholder='Provide Secret Password Here...'
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            onClick={HandleUpdate}
            mt={12}
            variant='solid'
            colorScheme='linkedin'
          >
            Update Changes
          </Button>
        </Container>
      </ChakraProvider>
    </>
  );
};
export default App;
